class TagManagerTracker {
  execute (action, category, label) {
    // debugger
    if (typeof dataLayer === 'undefined') {
      console.info('Tag Manager is not initialized.')
      return
    }
    dataLayer.push({
      event: 'asyncAction',
      gaHitType: 'event',
      category: category,
      action: action,
      label: label
    })
  }

  view = (category, label) => {
    this.execute('visualizzazione', category, label)
  }

  click = (category, label, action) => {
    this.execute(action || 'click', category, label)
  }
}

export default TagManagerTracker



// WEBPACK FOOTER //
// ./src/common/general/js/TagManagerTracker.js